export default "__VITE_ASSET__XUphZdab__"